import { render, staticRenderFns } from "./ResultSlot.vue?vue&type=template&id=39975776&scoped=true&"
import script from "./ResultSlot.vue?vue&type=script&lang=ts&"
export * from "./ResultSlot.vue?vue&type=script&lang=ts&"
import style0 from "./ResultSlot.vue?vue&type=style&index=0&id=39975776&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39975776",
  null
  
)

export default component.exports